import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import * as Icon from 'react-feather';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { connect } from 'react-redux';
import {
  setIsUserSettingsModalOpen,
  setIsOrderNotificationsModalOpen,
  setOrderNotificationsModalData,
} from '../../../../redux/modal/modal.actions';

import LabeledToggle from '../../form/LabeledToggle';
import {
  basePatchQuery,
  handleChangePassword,
} from '../../../../utility/sb-api/sb-api.service';
import { notification } from '../../../../utility/notification/notification.service';
import SettingLine from '../../form/fields/SettingLine';

const UserSettingsModal = ({
  isOpen,
  setIsUserSettingsModalOpen,
  me,
  setIsOrderNotificationsModalOpen,
  setOrderNotificationsModalData,
}) => {
  const intl = useIntl();
  const closeModal = () => setIsUserSettingsModalOpen(false);

  return (
    <>
      <ModalSheet
        isOpen={isOpen}
        closeModal={closeModal}
        title={intl.formatMessage({
          id: 'userSettingsModalTitle',
        })}
      >
        <div
          onClick={() => {
            setOrderNotificationsModalData({
              isClosable: true,
              noSignupModal: true,
            });
            setIsOrderNotificationsModalOpen(true);
          }}
          className="d-flex justify-content-center align-items-center"
        >
          <Icon.Bell size={20} className="primary" />
          <span className="ml-1 font-medium-1">
            <FormattedMessage id="orderNotificationSettingsLabel" />
          </span>
        </div>
        <hr />
        <div
          className="d-flex justify-content-center align-items-center"
          onClick={handleChangePassword}
        >
          <Icon.Lock
            data-testid="passwordChangeButton"
            size={20}
            className="primary"
          />
          <span className="ml-1 font-medium-1">
            <FormattedMessage id="passwordChageLabel" />
          </span>
        </div>
        <hr />
      </ModalSheet>
    </>
  );
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isUserSettingsModalOpen,
  store: state.store.store,
  me: state.me.me,
  data: state.modals.listAddressesModalData,
});

export default connect(mapStateToProps, {
  setIsUserSettingsModalOpen,
  setIsOrderNotificationsModalOpen,
  setOrderNotificationsModalData,
})(UserSettingsModal);
